import React from 'react'
import TreeView, { flattenTree } from 'react-accessible-treeview';
import { Card, CardBody, Col } from 'reactstrap';
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader';
import { basicTreeSubTitle } from '../../../Data/BonusUiData/TreeViewData';
import { BasicTreeTitle } from '../../../Utils/Constants';
import { ArrowIcon, CheckBoxIcon } from './Common/ArrowIcon';
import { db } from '../../../db/userDB';
import { useLiveQuery } from 'dexie-react-hooks';


export default function BasicTree() {
    const scopeData = useLiveQuery(() => db.scope.toArray());
    const permissionsArray = scopeData?.[0]?.scopes ?? [];
    const employeeData = useLiveQuery(() => db.employee.toArray());
    const employees = employeeData?.[0]?.employeeList ?? [];

    function objectToTree(obj: any): any[] {
        return Object.entries(obj).map(([key, value]) => {
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                // Nested object
                return {
                    name: key,
                    children: objectToTree(value)
                };
            } else {
                return {
                    name: `${key}: ${value}`
                };
            }
        });
    }
    const treeData = employees.map((emp, index) => ({
        name: `Employee`,
        children: objectToTree(emp)
    }));

    const formatted = permissionsArray.map(item => ({ name: item }));

    const simpleTreeviewData = {
        name: 'root',
        children: [
            {
                name: 'Login User',
                children: [
                    // {
                    //     name: 'Ecommerce',
                    //     children: [
                    //         { name: 'Product' },
                    //         { name: 'Cart' },
                    //         { name: 'Invoice' },
                    //     ],
                    // },
                    {
                        name: 'Permisions',
                        children: formatted,
                    },
                    {
                        name: 'Employee',
                        children: treeData,
                    },
                ],
            },],
    }
    const data = flattenTree(simpleTreeviewData);
    return (
        <Col sm={6} >
            <Card>
                <CommonCardHeader headClass='pb-0' title={BasicTreeTitle} subTitle={basicTreeSubTitle} />
                <CardBody>
                    <TreeView
                        data={data}
                        aria-label="Checkbox tree"
                        multiSelect
                        propagateSelect
                        propagateSelectUpwards
                        togglableSelect
                        nodeRenderer={({
                            element,
                            isBranch,
                            isExpanded,
                            isSelected,
                            isHalfSelected,
                            getNodeProps,
                            level,
                            handleSelect,
                            handleExpand,
                        }) => {
                            return (
                                <div
                                    {...getNodeProps({ onClick: handleExpand })}
                                    style={{ marginLeft: 40 * (level - 1), }}
                                >
                                    {isBranch && <ArrowIcon isOpen={isExpanded} />}
                                    {/* <CheckBoxIcon
                                        className="checkbox-icon"
                                        onClick={(e: React.MouseEvent<HTMLElement>) => {
                                            handleSelect(e);
                                            e.stopPropagation();
                                        }}
                                        variant={
                                            isHalfSelected ? "some" : isSelected ? "all" : "none"
                                        }
                                    /> */}
                                    <span className="name ms-2">{element.name}</span>
                                </div>
                            );
                        }}
                    />
                </CardBody>
            </Card>
        </Col >
    )
}
